export default "__VITE_ASSET__IAeFsQPC__"